import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
// import * as Highcharts from 'highcharts';
// declare var require: any

// require('highcharts/modules/exporting')(Highcharts);
// require('highcharts/modules/export-data')(Highcharts);
// require('highcharts/modules/annotations')(Highcharts);
// // require('highcharts/modules/solid-gauge')(Highcharts);
// // require('highcharts/modules/solid-gauge.src')(Highcharts);
// require('highcharts/highcharts');

import * as Highcharts from 'highcharts/highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import { color } from 'highcharts/highcharts.src';
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
// HighchartsMore(Highcharts);
// HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-lfsa-gh-gauge',
  templateUrl: './lfsa-gh-gauge.component.html',
  styleUrls: ['./lfsa-gh-gauge.component.css']
})
export class LfsaGhGaugeComponent implements OnInit {

  // @Input() dataLabel: [];
  @Input() data: number = 0;
  @Input() colorRojo: number = 0;
  @Input() colorAmarillo: number = 0;
  @Input() colorVerde: number = 0;
  @Input() loading: boolean = false;
  @Input() idComponent: string;
  @Input() title: string;
  @Input() unidad: string;
  @Input() unidadText: string;

  chart: Chart;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    let objSetting: any = {

      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '50%'
      },

      title: {
        text: this.title
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%'
      },

      // the value axis
      yAxis: {
        min: 0,
        // max: 100000,
        max: (this.colorVerde ),

        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '14px'
          }
        },
        plotBands: [
          {
            from: 0,
            to: this.colorRojo,
            // color: '#ff7f7f', // red
            color: '#FF334C',
            thickness: 20
          },
          {
            from: this.colorRojo,
            to: this.colorAmarillo,
            // color: '#ffffbf', // yellow
            color: '#FFFF00',
            thickness: 20
          },
          {
            from: this.colorAmarillo,
            to: this.colorVerde,
            // color: '#bfffbf', // green
            color: '#2ECC71',
            thickness: 20
          },
          {
            from: 200,
            to: 240,
            color: '#bfffbf', // green
            thickness: 20
          }
        ]
      },

      series: [{
        name: this.unidadText,
        data: [this.data],
        tooltip: {
          valueSuffix: ` ${this.unidad}`
        },
        dataLabels: {
          format: `{y} ${this.unidad}`,//'{y} Kg',
          borderWidth: 0,
          color: (
            Highcharts.defaultOptions.title &&
            Highcharts.defaultOptions.title.style &&
            Highcharts.defaultOptions.title.style.color
          ) || '#333333',
          style: {
            fontSize: '16px'
          }
        },
        dial: {
          radius: '80%',
          backgroundColor: 'gray',
          baseWidth: 12,
          baseLength: '0%',
          rearLength: '0%'
        },
        pivot: {
          backgroundColor: 'gray',
          radius: 6
        }

      }]

    }
    let chart = new Chart(objSetting);
    this.chart = chart;
    chart.ref$.subscribe(console.log);
  }

}
